export interface PhoneTrialUpsellEligibility {
  countryCode?: string;
  isPhoneVerified: boolean;
  planType?: string;
  userType?: string;
}

export const isPhoneTrialUpsellEligible = ({
  countryCode,
  isPhoneVerified,
  planType,
  userType,
}: PhoneTrialUpsellEligibility) =>
  countryCode === 'KR' &&
  !isPhoneVerified &&
  planType === 'FREE' &&
  userType?.toLowerCase() !== 'student';

/**
 * 휴대폰 인증 여부(/users/me)를 조회할 가치가 있는 사용자인지.
 *
 * `isPhoneTrialUpsellEligible` 중 **컨텍스트만으로 알 수 있는 조건**만 먼저 본다.
 * 인증 여부는 조회해야 알지만 나머지 셋은 이미 알고 있으니, 여기서 걸러내면
 * 해외·유료·학생 사용자의 프로필 조회를 통째로 없앨 수 있다.
 *
 * ⚠️ 위 함수와 짝이다. 한쪽 조건만 바꾸면 조회가 새거나(불필요) 모자란다(오판정).
 */
export const mayNeedPhoneVerificationCheck = ({
  countryCode,
  planType,
  userType,
}: Omit<PhoneTrialUpsellEligibility, 'isPhoneVerified'>) =>
  isPhoneTrialUpsellEligible({
    countryCode,
    planType,
    userType,
    // 인증 여부만 아직 모른다. 미인증이라고 가정했을 때도 대상이 아니면 조회할 이유가 없다.
    isPhoneVerified: false,
  });
